var enumerate = function enumerate() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var obj = {};
  args.forEach(function (arg, i) {
    obj[obj[arg] = i] = arg;
  });
  return obj;
};

export var TYPE = enumerate('BLOCKQUOTE', 'PULLQUOTE');
export var FLOAT = enumerate('NONE', 'LEFT', 'RIGHT');